import React from 'react';
import RecruiterSidebar from '../components/RecruiterSidebar';
import Messages from './Messages';

export default function RecruiterMessages() {
  return <Messages SidebarComponent={RecruiterSidebar} />;
}
